export default __webpack_public_path__ + "static/media/17.942f8107.jpg";